interface BrowserDeviceInput {
   userAgent: string;
   platform?: string;
   maxTouchPoints?: number;
}

export function detectBrowserDevice({
   userAgent,
   platform,
   maxTouchPoints = 0,
}: BrowserDeviceInput) {
   const isAndroid = /android/i.test(userAgent);
   // iPadOS uses a desktop Mac user agent when requesting desktop websites.
   const isIOS =
      !isAndroid &&
      (/iPad|iPhone|iPod/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1));

   return { isMobile: isIOS || isAndroid, isIOS, isAndroid };
}
